// removed by extract-text-webpack-plugin
module.exports = {"label":"Dropdown-label"};